import backend from "../../api/api";
import { store } from "../../redux/store";
import { message } from "antd";

const getConfig = () => {
  const token = store.getState().auth.token;
  return {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
};

// ✅ Fetch Pathao Cities
export const getPathaoCities = async () => {
  try {
    const response = await backend.get("api/courier/pathao/cities/", getConfig());
    
    // Debug: Log the full response to see structure
    console.log("Full API Response:", response);
    console.log("Response Data:", response.data);
    
    // Try different possible data locations
    let cities = null;
    
    if (response && response.data && response.data.data && response.data.data.data && response.data.data.data.data) {
      cities = response.data.data.data.data;
      console.log("Found cities at: response.data.data.data");
    } else if (response && response.data && response.data.data) {
      cities = response.data.data;
      console.log("Found cities at: response.data.data");
    } else if (response && response.data) {
      cities = response.data;
      console.log("Found cities at: response.data");
    }
    
    console.log("Extracted cities:", cities);
    
    // Ensure it's an array
    if (!Array.isArray(cities)) {
      console.warn("Cities is not an array:", typeof cities);
      return [];
    }
    
    return cities;
  } catch (error) {
    console.error("Failed to fetch cities:", error);
    console.error("Error response:", error.response);
    message.error("Failed to fetch Pathao cities");
    return [];
  }
};

// ✅ Fetch Zones by City
export const getPathaoZones = async (cityId) => {
  try {
    const response = await backend.get(
      `api/courier/pathao/cities/${cityId}/zones/`,
      getConfig()
    );
    console.log("Zones Response:", response.data);
    
    if (response && response.data && response.data.data && response.data.data.data && response.data.data.data.data) {
      return response.data.data.data.data;
    } else if (response && response.data && response.data.data) {
      return response.data.data;
    }
    return [];
  } catch (error) {
    console.error("Failed to fetch zones:", error);
    message.error("Failed to fetch Pathao zones");
    return [];
  }
};

// ✅ Fetch Areas by Zone
export const getPathaoAreas = async (zoneId) => {
  try {
    const response = await backend.get(
      `api/courier/pathao/zones/${zoneId}/areas/`,
      getConfig()
    );
    console.log("Areas Response:", response.data);
    
    if (response && response.data && response.data.data && response.data.data.data && response.data.data.data.data) {
      return response.data.data.data.data;
    } else if (response && response.data && response.data.data) {
      return response.data.data;
    }
    return [];
  } catch (error) {
    console.error("Failed to fetch areas:", error);
    message.error("Failed to fetch Pathao areas");
    return [];
  }
};

// ✅ Fetch Stores
export const getPathaoStores = async () => {
  try {
    const response = await backend.get("api/courier/pathao/stores/", getConfig());
    console.log("Stores Response:", response.data);
    
    if (response && response.data && response.data.data && response.data.data.data && response.data.data.data.data) {
      return response.data.data.data.data;
    } else if (response && response.data && response.data.data) {
      return response.data.data;
    }
    return [];
  } catch (error) {
    console.error("Failed to fetch stores:", error);
    message.error("Failed to fetch Pathao stores");
    return [];
  }
};